<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑       永不宕机     永无BUG
 *
 * @Author: DY
 * @Date: 2022-02-23 18:36:00
 * @LastEditTime: 2022-02-24 15:52:02
 * @Description: 计划详情-粉料
 * @Param:
 * @FilePath: \JT_Mobile_test\src\views\salesTerminal\supplyPlan\planDetails_fl.vue
 -->

<template>
    <div class="commonFormStyles planDetails_fl">
        <div class="info">
            <h4>申请场站：{{ planBasicInfo.station_name }}</h4>
            <p class="iconfont iconwenjianguanli">
                计划编号：{{ planBasicInfo.no }}
            </p>
            <p class="iconfont icondaqiayueli">
                供应日期：{{ planBasicInfo.supply_date }}
            </p>
            <p class="iconfont iconshijian">
                要求送货时间：{{ planBasicInfo.time_required }}
            </p>
            <p class="iconfont iconwode">
                申请人：{{ planBasicInfo.operation_name }}
            </p>
            <p class="iconfont iconshijian">
                申请时间：{{ planBasicInfo.report_date }}
            </p>
            <p class="iconfont icontianjiabeizhu">
                备注：{{ planBasicInfo.remarks }}
            </p>
        </div>
        <ul class="materialList">
            <template v-for="(item, index) in planBasicMaterialList">
                <li :key="`material_${index}`">
                    <h3>原材料分类：{{ item.type_name }}</h3>
                    <p>
                        <span>原材料子类：{{ item.goods_name }}</span>
                    </p>
                    <p>
                        <span>原材料规格：{{ item.spec_name }}</span>
                    </p>
                    <p>
                        <span>数量：{{ item.plan_count }}{{ item.measure_unit }}</span>
                    </p>
                </li>
            </template>
        </ul>
    </div>
</template>
<script>
export default {
    name: '',
    components: {},
    props: {},
    data() {
        return {
            plan_id: '',
            planBasicInfo: {},
            planBasicMaterialList: [],
        };
    },
    computed: {},
    watch: {},
    async created() {
        this.plan_id = this.$route.params.plan_id;
        this.planBasicInfo = await this.getPlanBasicInfo(this.plan_id);
        this.planBasicMaterialList = await this.getPlanBasicMaterialList(this.plan_id);
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 获取计划基础信息
        getPlanBasicInfo(planId) {
            return this.$axios.$get(`/interfaceApi/procurement/daily/plan/get/${planId}`, { defEx: true });
        },

        // 获取计划粉料数据
        getPlanBasicMaterialList(planId) {
            return this.$axios.$get(`/interfaceApi/procurement/daily/plan/allgoods/${planId}`, { defEx: true });
        },
    },
};
</script>
<style lang="stylus" scoped>
.planDetails_fl
    height 100%
    background: #F0F0F0
    .info
        padding 12rpx
        background #FFFFFF
        box-shadow 0px 0px 6px 0px rgba(0, 0, 0, 0.3)
        h4
            font-size 16rpx
            color #1F2229
            font-weight 600
        p
            flex 1
            font-size 14rpx
            color #626262
            margin-top: 8rpx
    .materialList
        padding: 14rpx
        li
            background #FFFFFF
            box-shadow 1px 1px 4px 0px rgba(84, 148, 243, 0.5)
            border 1px solid #D7D7D7
            margin-bottom: 14rpx
            &:last-child
                margin-bottom: 0
            h3
                height: 40rpx
                line-height: 40rpx
                font-size 18rpx
                color #2978FF
                padding 0 12rpx
                background: rgba(85, 136, 241, 0.06)
                font-family youSheBiaoTiHei
                margin-bottom: 12rpx
            p
                overflow hidden
                padding 0 12rpx
                margin-bottom 12rpx
                img,span
                    float left
                    height 16rpx
                    line-height 16rpx
                img
                    width 16rpx
                    margin-right 12rpx
                span
                    display inline-block
                    width calc(100% - 40rpx)
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                    font-size 14rpx
                    color #666666
</style>